const commonMoodlePayload = {
  moodlewsrestformat: "json",
};

export { commonMoodlePayload };
